/* Lecteur vidéo auto-hébergé Pacha (remplace les embeds Vimeo).
   Conteneur : [data-pv]  ·  vidéo : <video class="pv__el" data-hd data-sd>
   Éléments masqués pendant la lecture : [data-pv-hide]  ·  déclencheur : [data-pv-trigger]
   Commandes : pause/lecture + son, en bas à droite. Pas de barre de progression. */
(function () {
  'use strict';

  var SVG = {
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="7" y="5" width="3.6" height="14" rx="1.2"/><rect x="13.4" y="5" width="3.6" height="14" rx="1.2"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.2v13.6L19 12 8 5.2z"/></svg>',
    sound: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M15.2 8.6a4.6 4.6 0 0 1 0 6.8" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><path d="M17.9 5.9a8.3 8.3 0 0 1 0 12.2" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>',
    muted: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M15.6 9.6l5.4 4.8M21 9.6l-5.4 4.8" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>'
  };

  var DICT = {
    fr: { pause: 'Pause', play: 'Lecture', mute: 'Couper le son', unmute: 'Activer le son' },
    en: { pause: 'Pause', play: 'Play', mute: 'Mute', unmute: 'Unmute' },
    de: { pause: 'Pause', play: 'Abspielen', mute: 'Ton aus', unmute: 'Ton an' },
    nl: { pause: 'Pauzeren', play: 'Afspelen', mute: 'Geluid uit', unmute: 'Geluid aan' },
    pl: { pause: 'Pauza', play: 'Odtwórz', mute: 'Wycisz', unmute: 'Włącz dźwięk' },
    da: { pause: 'Pause', play: 'Afspil', mute: 'Slå lyden fra', unmute: 'Slå lyden til' }
  };

  function words(box) {
    var lang = (box.getAttribute('data-pv-lang') || document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    return DICT[lang] || DICT.fr;
  }

  function button(cls, label, svg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pv__ctrl ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg;
    return b;
  }

  function init(box) {
    if (box.__pv) return;
    var video = box.querySelector('video.pv__el');
    if (!video) return;
    box.__pv = true;

    var W = words(box);
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    var saveData = conn.saveData === true;
    var slowNet = /(^|-)(2g|slow-2g)$/.test(conn.effectiveType || '');
    var wide = Math.max(window.innerWidth || 0, document.documentElement.clientWidth || 0) >= 900;

    var hd = video.getAttribute('data-hd') || '';
    var sd = video.getAttribute('data-sd') || hd;
    var src = (wide && !saveData && !slowNet && hd) ? hd : sd;
    if (src && !video.getAttribute('src')) video.setAttribute('src', src);

    // preload="none" : aucun octet tant que le visiteur n'approche pas / ne clique pas.
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      try { video.preload = 'auto'; video.load(); } catch (e) {}
    }
    box.addEventListener('mouseenter', warm);
    box.addEventListener('touchstart', warm, { passive: true });

    // Préchauffage optionnel à l'entrée dans l'écran (opt-in : data-pv-prefetch="1").
    if (box.getAttribute('data-pv-prefetch') === '1' && 'IntersectionObserver' in window && typeof fetch === 'function') {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        io.disconnect();
        if (saveData || slowNet || warmed) return;
        fetch(video.currentSrc || src, { headers: { Range: 'bytes=0-1048575' } }).catch(function () {});
      }, { rootMargin: '300px' });
      io.observe(box);
    }

    // ── Affiche + gros bouton Play générés (data-pv-autoui) ───────────────
    if (box.getAttribute('data-pv-autoui') === '1') {
      var posterSrc = video.getAttribute('poster');
      if (posterSrc && !box.querySelector('.pv__poster')) {
        var img = document.createElement('img');
        img.className = 'pv__poster';
        img.src = posterSrc;
        img.alt = box.getAttribute('data-pv-alt') || '';
        img.loading = 'lazy';
        img.setAttribute('data-pv-hide', '');
        box.appendChild(img);
      }
      if (!box.querySelector('.pv__big')) {
        var big = document.createElement('button');
        big.type = 'button';
        big.className = 'pv__big';
        big.setAttribute('aria-label', W.play);
        big.setAttribute('data-pv-trigger', '');
        big.setAttribute('data-pv-hide', '');
        big.innerHTML = SVG.play;
        box.appendChild(big);
      }
    }

    // ── Commandes ──────────────────────────────────────────────────────────
    var bar = document.createElement('div');
    bar.className = 'pv__ctrls';
    var bPlay = button('pv__ctrl--pp', W.pause, SVG.pause);
    var bSound = button('pv__ctrl--sound', W.mute, SVG.sound);
    bar.appendChild(bPlay);
    bar.appendChild(bSound);
    box.appendChild(bar);

    function syncPlay() {
      var paused = video.paused;
      bPlay.innerHTML = paused ? SVG.play : SVG.pause;
      bPlay.setAttribute('aria-label', paused ? W.play : W.pause);
    }
    function syncSound() {
      var off = video.muted || video.volume === 0;
      bSound.innerHTML = off ? SVG.muted : SVG.sound;
      bSound.setAttribute('aria-label', off ? W.unmute : W.mute);
    }

    bPlay.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
    });
    bSound.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.muted || video.volume === 0) { video.muted = false; if (!video.volume) video.volume = 1; }
      else { video.muted = true; }
      syncSound();
    });

    video.addEventListener('play', syncPlay);
    video.addEventListener('pause', syncPlay);
    video.addEventListener('volumechange', syncSound);
    video.addEventListener('click', function () {
      if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
    });
    video.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    // ── Démarrage : clic sur le bouton Play → lecture avec le son ─────────
    function start(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      warm();
      box.classList.add('pv-on');
      video.muted = false;
      video.volume = 1;
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          // Filet : si le navigateur refuse le son, on lit en muet et le bouton propose de l'activer.
          video.muted = true;
          syncSound();
          video.play().catch(function () {});
        });
      }
      syncPlay();
      syncSound();
    }

    var triggers = box.querySelectorAll('[data-pv-trigger]');
    for (var i = 0; i < triggers.length; i++) triggers[i].addEventListener('click', start);
    box.__pvStart = start;

    // Pop-up refermé / conteneur masqué : on coupe le son au lieu de le laisser jouer.
    // Le pop-up se ferme via opacity/visibility, qu'un IntersectionObserver ne voit pas :
    // on surveille donc les changements de classe pendant la lecture seulement.
    if (box.getAttribute('data-pv-pause-hidden') === '1' && typeof MutationObserver === 'function') {
      var mo = null, queued = false;
      var isHidden = function () {
        var el = box;
        while (el && el.nodeType === 1) {
          var st = window.getComputedStyle(el);
          if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) === 0) return true;
          el = el.parentNode;
        }
        return false;
      };
      var check = function () {
        if (queued) return;
        queued = true;
        (window.requestAnimationFrame || setTimeout)(function () {
          queued = false;
          if (!video.paused && isHidden()) video.pause();
        }, 0);
      };
      video.addEventListener('play', function () {
        if (mo) return;
        mo = new MutationObserver(check);
        mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden'] });
      });
      video.addEventListener('pause', function () {
        if (mo) { mo.disconnect(); mo = null; }
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && !video.paused) video.pause();
      });
    }

    // Fin de lecture : retour à l'affiche + bouton Play, comme avant la première lecture.
    video.addEventListener('ended', function () {
      if (video.loop) return;
      box.classList.remove('pv-on');
      try { video.currentTime = 0; } catch (err) {}
      syncPlay();
    });
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-pv]');
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.PachaVideo = { boot: boot };
})();
